export default class TagService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntity(id) {
		return this.apiService.callGet('me/versionRedirects/' + id)
	}

	getEntities(params) {
		return this.apiService.callGet('me/versionRedirects', params)
	}

	createEntity(params){
		return this.apiService.callPost('me/versionRedirects', params);
	}

	updateEntity(id, params){
		return this.apiService.callPut('me/versionRedirects/'+id, params);
	}

	deleteEntity(id) {
		return this.apiService.callDelete('me/versionRedirects/' + id)
	}
}



// WEBPACK FOOTER //
// ./src/service/VersionRedirectService.js